<div class="contract-details-container">
    <nav class="breadcrumbs">
        <a class="crumb crumb-link" (click)="goToExtensions()">
            <i class="fa fa-chevron-left"></i>&nbsp;{{ "extensions.breadcrumbRoot" | translate }}
        </a>
        <span class="crumb-sep">/</span>
        <span class="crumb current">{{ ownerLabel }}</span>
    </nav>
    <div class="contract-details-header">
        <div class="headings">
            <h3 class="page-title">{{ taskTitle }}</h3>
            <p class="page-subtitle">{{ "contractDetails.heading" | translate: { owner: ownerLabel } }}</p>
        </div>
        <button
            class="btn btn-primary btn-online-primary"
            (click)="openModal()"
        >
            {{ "contractDetails.createNewTitle" | translate }}
        </button>
    </div>
    <div class="grid-container">
        <ag-grid-angular
            style="width: 100%; height: 100%"
            [rowData]="contractDetailsList"
            [columnDefs]="colDefs"
            [defaultColDef]="defaultColDef"
            (cellEditingStarted)="onCellEditingStarted($event)"
            (cellEditingStopped)="onCellEditingStopped($event)"
            [getRowStyle]="getRowStyle"
            (gridReady)="onGridReady($event)"
            [autoGroupColumnDef]="autoGroupColumnDef"
            [stopEditingWhenCellsLoseFocus]="true"
            [enableBrowserTooltips]="true"
        />
    </div>
</div>
